import ApiClient from './ApiClient';
class ImagesClient extends ApiClient {
  constructor() {
    super('/image-generation/v1');
  }
}

const imagesClient = new ImagesClient();

export default imagesClient;
